var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-yahei",attrs:{"id":"app"}},[_c('Header',{attrs:{"content":_vm.content,"mode":_vm.mode,"nav-color":_vm.navColor}}),_c('router-view'),_c('Footer',{attrs:{"footer":_vm.content.footer,"bg-color":_vm.bgColor,"sub-bg-color":_vm.subBgColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }